// useAuthorizedSites.js
// 🎯 المواقع اللي اليوزر مسموح له يشوفها (زي Security Groups في Maximo):
// مواقع الرولات + اللي اتضاف له في شاشة اليوزر - اللي اتشال منه، والموقع
// الافتراضي دايمًا. الشاشات بتستخدمها عشان تظهر "كل المواقع" ودروب داون
// المؤسسة/الموقع لأي حد عنده أكتر من موقع مش للسوبر أدمن بس
import { useEffect, useState } from 'react';
import axios from 'axios';

let cache = { token: null, promise: null };

const load = (token) => {
  if (cache.token !== token || !cache.promise) {
    cache = {
      token,
      promise: axios.get('/api/me/authorized-sites', { headers: { Authorization: `Bearer ${token}` } })
        .then(res => res.data)
        .catch(() => { cache = { token: null, promise: null }; return null; }),
    };
  }
  return cache.promise;
};

const groupByOrg = (sites) => {
  const orgs = [];
  sites.forEach(site => {
    let org = orgs.find(o => o.org_id === site.org_id);
    if (!org) { org = { org_id: site.org_id, sites: [] }; orgs.push(org); }
    org.sites.push(site);
  });
  return orgs;
};

export const useAuthorizedSites = () => {
  const [state, setState] = useState({ loaded: false, allSites: false, sites: [], orgs: [], multiSite: false });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return undefined;
    let alive = true;
    load(token).then(data => {
      if (!alive || !data) return;
      const sites = data.sites || [];
      setState({
        loaded: true,
        allSites: !!data.all_sites,
        sites,
        orgs: groupByOrg(sites),
        multiSite: !!data.all_sites || sites.length > 1,
      });
    });
    return () => { alive = false; };
  }, []);

  return state;
};
